const serviceUrl = `${__configuration.apiUrl}/massia/associes`;

export default class AssociesService {
    static $inject = ['$http'];

    constructor($http) {
        this.$http = $http;
    }

    async getAssocies(filters, sorts, pagination) {
        const res = await this.$http.get(serviceUrl, {
            params: {
                filters: JSON.stringify(filters || []),
                sorts: JSON.stringify(sorts || []),
                pagination: JSON.stringify(pagination || {})
            }
        });

        return res.data;
    }

    async deleteAssocieById(id) {
        const url = `${serviceUrl}/${id}`;
        return this.$http.delete(url);
    }

    async getAssocieById(id) {
        const url = `${serviceUrl}/${id}`;
        const res = await this.$http.get(url);
        return res.data;
    }

    async createAssocie(selectedAssocie) {
        const data = {
            code: selectedAssocie.code,
            libelle: selectedAssocie.libelle
        };
        const result = await this.$http.post(serviceUrl, data);
        return result.data;
    }

    async updateAssocie(selectedAssocie) {
        const data = {
            id: selectedAssocie.id,
            code: selectedAssocie.code,
            libelle: selectedAssocie.libelle
        };
        const url = `${serviceUrl}/${data.id}`;
        return this.$http.put(url, data);
    }

    async codeExists(code) {
        const url = `${serviceUrl}/code-unicity/${code}`;
        const result = await this.$http.get(url);
        return result.data;
    }
}
